module.exports = __webpack_public_path__ + "83dc0e0c14eb95cb08e5fbb41f728dcc.png";